



















import Vue from 'vue';
import Component from 'vue-class-component';
import transition from 'vue';
import SurveyService from '@/services/SurveyService';
import QuestionService from '@/services/QuestionService';
import Loader from '@/components/loader/Loader.vue';
import { mapGetters, mapActions } from 'vuex';
import { SurveyModule } from '@/store/modules/Survey';
import { QuestionModule } from '@/store/modules/Question';
import { AnswerModule } from '@/store/modules/Answer';
import { ChoiceModule } from '@/store/modules/Choice';
import { UserModule } from '@/store/modules/User';

@Component({
	components: {
		'star-rating': () => import('@/components/survey/components/StarRating.vue'),
		'free-text': () => import('@/components/survey/components/FreeText.vue'),
		'boolean': () => import('@/components/survey/components/Boolean.vue'),
		'radio': () => import('@/components/survey/components/Radio.vue'),
		'checkbox': () => import('@/components/survey/components/CheckBox.vue'),
		'select-box': () => import('@/components/survey/components/Select.vue'),
		'loader': Loader
	}
})
export default class SurveyComponent extends Vue {

	private errorRequired = false;

	get nextButtonText(): string {
		return this.percentageCompleted !== 100 ? 'Next question' : 'Finish survey';
	}

	get percentageCompleted() {
		return QuestionModule.percentageCompleted;
	}

	get choices() {
		return ChoiceModule.choices;
	}

	get nextQuestionId() {
		return QuestionModule.nextQuestionId;
	}

	get answer() {
		return AnswerModule.answer;
	}

	get showActiveQuestion() {
		return SurveyModule.showActiveQuestion;
	}

	get activeQuestion() {
		return QuestionModule.activeQuestion;
	}

	get user() {
		return UserModule.user;
	}

	/*
	 * Initialize data when component is created
	 */
	private created() {
		if (SurveyModule.survey === null) {
			SurveyModule.loadSurvey(1).then(() => {
				// TODO remove static id
				QuestionModule.loadQuestions(1).then(() => {
					QuestionModule.updateActiveQuestion(QuestionModule.questions[0]);
					// this.nextQuestionId = QuestionModule.activeQuestion.nextQuestionId;
					SurveyModule.setShowActiveQuestion(true);
				});
			});
		}
	}

	private showRequiredError() {
		this.errorRequired = true;
		setTimeout(() => {
			this.errorRequired = false;
		}, 2500);
	}

	/**
	 * Hide question, save answer, load next question, set question visible.
	 */
	private nextQuestion() {
		// Check required
		if (QuestionModule.activeQuestion.required && ChoiceModule.choice[0] === '') {
			this.showRequiredError();
		} else {
			// Hide question
			SurveyModule.setShowActiveQuestion(false);
			// Save answer
			AnswerModule.saveAnswer().then(
				this.loadNextQuestion,
				() => {
					// TODO Error handling
					SurveyModule.setShowActiveQuestion(true);
				});
		}
	}

	/**
	 * Load next question or jumps to certificate-page if all questions are answered
	 */
	private async loadNextQuestion(success: boolean) {
		if (success) {
			// Load next question or finish survey
			if (this.percentageCompleted === 100) {
				if (UserModule.user) {
					// Set finished status
					UserModule.setSurveyFinished(true);
					// Save user
					UserModule.saveUser(UserModule.user).then( () => {
						// Go to certificate page
						this.$router.push({name: 'certificate'});
					});
				}
			} else {
			// Load next question
			await QuestionModule.loadQuestion(QuestionModule.nextQuestionId);
			}
		}
		SurveyModule.setShowActiveQuestion(true);
	}
}
